import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { SquareCustomerGroup } from '../../../../../../../models/organization-config';


@Component({
  selector: 'app-set-square-customer-groups-managed-by-capitan-modal',
  templateUrl: './set-square-customer-groups-managed-by-capitan-modal.component.html',
  styleUrls: ['./set-square-customer-groups-managed-by-capitan-modal.component.css']
})
export class SetSquareCustomerGroupsManagedByCapitanModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public squareCustomerGroupList: SquareCustomerGroup[];

  public loadingSquareCustomerGroups = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.loadSquareCustomerGroups();
  }

  public handleSubmit() {
    if (this.loadingSquareCustomerGroups) { return; }

    this.loadingSave = true;
    this.errorMessage = '';

    this.orgConfigService
      .setSquareCustomerGroupsManagedByCapitan(this.squareCustomerGroupList)
      .then(() => {
        this.savedCallback({
          text: 'Square customer groups updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to configure Square customer groups.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadSquareCustomerGroups(): Promise<void> {
    this.loadingSquareCustomerGroups = true;

    return this.orgConfigService
      .syncSquareCustomerGroups()
      .then(() => {
        return this.orgConfigService.getSquareCustomerGroups();
      })
      .then(response => {
        this.squareCustomerGroupList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to configure Square customer groups.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSquareCustomerGroups = false; });
  }

}
